module.exports = __webpack_public_path__ + "static/michal-photo-2b441f7445db8f2649101b873672ef99.jpg";